import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export class hideSticky {

    /**
    * Constructs a new hide sticky 
    *
    * @param stickyItem Element sticky
    * @param elementsXL : array : élement à eviter
    */

    constructor(stickyItem, elementsXL) {
        this.selector = stickyItem;
        this.elementsXL = elementsXL;
        this.margeSticky = document.querySelector('.nav-desktop').offsetHeight + 50
    }

    /**
   * Find elements
   * Ajouter dans votre sélecteur, un element avec la class en sticky 
   * @return {void}
   */
    findElements() {
        this.el = document.querySelector(this.selector + ' .sticky');

    }

    /**
   * Find any elements and hide 
   * @return {void}
   */
    init() {
        this.findElements();
        this.hideElement();
    }


    delete() {
        this.findElements();
        this.el.removeAttribute('style');
    }


    hideElement() {
        const sticky = this.el;


  

        if (sticky) {
         

            let stickyHeight = sticky.offsetHeight + this.margeSticky;
            let bottomSticky = window.innerHeight - stickyHeight;
            let spaceAvailableNext = 9999;//space unlimited
            let spaceAvailablePrev = 9999;//space unlimited

     
            this.elementsXL.forEach((item, index) => {


                ScrollTrigger.create({
                    trigger: item,
                    start: "top-=20px bottom-=" + bottomSticky + "px",
                    end: "bottom+=20px " + this.margeSticky + "px",
                    scrub: false,
                    //markers: { startColor: "blue", endColor: "yellow", indent: 20 },
                    toggleActions: "play play play play",
                    onEnter: () => {
                        console.log("onEnter");
                        gsap.to(sticky, { opacity: "0", duration: 0.2 });
                    },

                    onLeave: () => {
                        console.log("onLeave");
                        //next el
                
                        if (index + 1 < this.elementsXL.length) {
                            console.log( 'test' );
                            let elCurentBottom = this.elementsXL[index].offsetTop + this.elementsXL[index].offsetHeight;
                            let elNextTop = this.elementsXL[index + 1].offsetTop;
                            spaceAvailableNext = elNextTop - elCurentBottom;
                        }else if( index + 1 === this.elementsXL.length ) {
                            // c'est le dernier élement 
                            spaceAvailableNext = 9999;
                        }

                        if (spaceAvailableNext >= stickyHeight) {
                            gsap.to(sticky, { opacity: "1", duration: 0.5 })
                        }

                    },

                    onLeaveBack: () => {
                        console.log("onLeaveBack");
                        // prev el
                        if (index - 1 >= 0) {
                            let elCurentTop = this.elementsXL[index].offsetTop;
                            let elPrevBottom = this.elementsXL[index - 1].offsetTop + this.elementsXL[index - 1].offsetHeight;
                            spaceAvailablePrev = elCurentTop - elPrevBottom;
                        }

                        if (spaceAvailablePrev >= stickyHeight) {
                            gsap.to(sticky, { opacity: "1", duration: 0.5 })
                        }
                    },

                    onEnterBack: () => {
                        console.log("onEnterBack");
                        gsap.to(sticky, { opacity: "0", duration: 0.3 })
                    },
                });

            });

        }


    }
}